import React, { useState , useEffect  } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader, Row, Col, ListGroupItem, ListGroup} from 'reactstrap';
import { Link } from 'react-router-dom';
import { get_all_users, get_group_user_bot_id , add_user_to_bot } from '../../../../helpers/fakebackend_helper';
import { Add_Bot_User, Delete_Bot_User } from '../../../../slices/thunks';
import { Loader } from 'feather-icons-react/build/IconComponents';
import { useDispatch } from 'react-redux';
import { waitForDecision } from '../../../../utility/wait_for_confirmation';
import { close_confirm_modal, open_confirm_modal } from '../../../../slices/Confirm_Modal/reducer';


const Add_New_User_modal = () => {
    const dispatch = useDispatch()

    const [modal_standard, setmodal_standard] = useState(false);

    const [User_Role, setUser_Role] = useState('BotUser')
    const [user, setuser] = useState([])
    const {Bot_ID , Assets_ID , loading  } = useSelector((state) => state.BotDetails.Bot_Details);
    const {Bot_User } = useSelector((state) => state.BotDetails);
    const [selected_user, setselected_user] = useState('')
    const { Group_Users } = useSelector((state)=>state.GroupOwner) 
    const [added_user, setadded_user] = useState([])


    useEffect(() => {
       
        // get_group_user_bot_id({ bot_id:Bot_ID }).then((result)=>{
           
            
            
        //     setuser(result)
            
        // }).catch((err)=>{
        //      console.log(err);
             
        // })
         const Bot_Users_String = JSON.stringify(Bot_User)

         
         
        let temp = Group_Users.filter((ele)=>{
            return !Bot_Users_String.includes(ele.User_Name) && ele.Invite_Acceptance_Status
        })

        temp = temp.map((ele)=>{
            return {...ele, IsAssigned:'False'}
        })

        setuser(temp)


    }, [Bot_User])


    const onClick_Add_user_to_bot = ()=>{
        
        dispatch(Add_Bot_User({ 
            Bot_ID,
            assistant_id:Assets_ID,
            Users:added_user

         }))

    }
    

    function tog_standard_add_new_user() {
        setmodal_standard(!modal_standard);
    }


    const onClick_Add_user =()=>{


        
        
        

        if(selected_user ){
            
            setadded_user([...added_user , {User_Group_ID:selected_user.User_Group_ID,Type:User_Role , User_Name:selected_user.User_Name } ])
            setselected_user('')

        }

        const temp_user = user.map((ele)=>{
                if(ele.User_Name === selected_user.User_Name){
                    ele.IsAssigned = 'True'
                }

                return ele
        })

        


        setuser(temp_user)
        
        
        


    }


    const delete_from_Selected = (User_Name)=>{
      const temp = added_user.filter((ele)=> ele.User_Name !== User_Name )
      setadded_user(temp)

      const temp_user = user.map((ele)=>{
        if(ele.User_Name === User_Name){
            ele.IsAssigned = 'False'
        }

        return ele
})




setuser(temp_user)
    }





  return (
    <>
      <Button color="secondary float-end" onClick={() => tog_standard_add_new_user()}>Add User to Bot</Button>
      {/* Default Modal */}
        <Modal id="myModal"
            isOpen={modal_standard}
            toggle={() => {
                tog_standard_add_new_user();
            }}
        >
            <ModalHeader className="modal-title"
                id="myModalLabel" toggle={() => {
                    tog_standard_add_new_user();
                }}> 
                Add New User
            </ModalHeader>
            {loading?<Loader/>:<ModalBody>
                <div className='add_new_user_inner'>
                    <Row>
                        <Col md={5}>
                            <div className='user_name'>
                              <p> User Name </p>
                              <select onChange={(e)=>{
                                const value  = e.target.value?JSON.parse(e.target.value):""
                                setselected_user(value)
                              }} class="form-select mb-3" aria-label=".form-select-lg example">
                                <option></option>
                                {
                                    user.map((ele,i)=>{

                                        if(ele.IsAssigned !== 'True'){

                                            return <option key={i} value={JSON.stringify(ele)}>{ele.User_Name}</option>
                                        }else{
                                            return " "
                                        }

                                    })
                                }
                         
                            </select>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className='user_type'>
                              <p> User Type</p>
                              <select onChange={(e)=>{
                                 setUser_Role(e.target.value)
                              }} class="form-select mb-3" aria-label=".form-select-lg example">
                                <option value={" "} ></option>
                              <option selected={User_Role==='BotUser'} value="BotUser">Bot User</option>
                                <option selected={User_Role==='BotAdmin'} value="BotAdmin">Bot Admin</option>
                                <option selected={User_Role==='Viewer'} value="Viewer">Viewer</option>
                            </select>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className='user_add'>
                            <Button onClick={onClick_Add_user}  color="secondary" className="btn-icon" style={{width:'100%'}}>
                                {/* <i class="ri-add-line"></i> */}
                                Add to list
                                </Button>
                            </div>
                        </Col>
                    </Row>                 
                    
                    <div className="new_user_list">
                    <ListGroup style={{marginBottom:'15px'}}>
                        <ListGroupItem style={{marginBottom:'5px'}}>
                            {
                                 added_user.map((ele,i)=>{
                                
                                    
                                    return    <div key={i} className="new_user_list_inner">
                                    <div class="user">{ele.User_Name}</div>
                                    <div class="type">{ele.Type}</div>
                                    <div class="remove"><button className="btn btn-soft-dark btn-icon" onClick={()=>{
                                        delete_from_Selected(ele.User_Name)
                                    }}  > <i className="ri-delete-bin-5-line"/> </button></div>
                              </div>
                                })
                            }
                        
                        </ListGroupItem>
                    </ListGroup>
                    </div>

                    <div className="modal-footer">                
                        <Button
                            color="secondary"
                            onClick={()=>{
                                onClick_Add_user_to_bot()
                            }}
                        >
                            Confirm
                        </Button>
                        <Button
                            color="light"
                            onClick={() => {
                                tog_standard_add_new_user();
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </ModalBody>}
            
        </Modal>
    </>
  )
}

export default Add_New_User_modal
